<template>
  <div class="custom-tree" ref="treeBox">
    <vxe-list height="300" class="custom-tree__row" auto-resize :loading="false" :data="options">
      <template #default="{ items }">
        <div class="custom-tree__row" v-for="item in items" :key="item[props.id]"
          :class="[`leaf-${item.level}`, {'has-child': item.haveChild, 'is-expand': item.expand}, {'custom-tree__active':(!showCheckbox && checkedItem && checkedItem[props.id]===item[props.id])}]"
          :style="{paddingLeft: `${item.level * 10}px`}">
          <div v-show="item.show">
            <i :class="{'el-icon-caret-bottom':item.expand,'el-icon-caret-right':!item.expand}" v-if="!!item.haveChild"
              @click="toggleTreeNode(item)"></i>
            <i v-else class="el-icon__empty"></i>
            <el-checkbox v-model="item.checked" @change="checkChange(item)" :disabled="item.readonly"
              v-if="showCheckbox"></el-checkbox>
            <span class="custom-tree__label"
              :class="{'custom-tree__delete':item.Status===-1,'custom-tree__disabled':item.readonly}"
              @click="checkChange(item,true)">{{ getLabel(item) }}</span>
          </div>
        </div>
      </template>
    </vxe-list>
  </div>
</template>

<script>
import XEUtils from 'xe-utils'
export default {
  name: 'yblTree',
  model: {
    prop: 'data',
    event: 'change'
  },
  props: {
    data: {
      type: Array | Object,
      default: () => []
    },
    checked: {
      type: Array | String,
      default: () => []
    },
    props: {
      type: Object,
      default () {
        return { label: 'label', children: 'children', id: 'id', parentId: 'parentId', status: 'Status', statusValue: '-1' }
      }
    },
    showCheckbox: {
      type: Boolean,
      default: () => true
    },
    filterDelete: { // 筛选是否显示已删除的机构
      type: Boolean,
      default: () => true
    },
    size: {
      type: Number,
      default: () => 120
    }
  },
  data () {
    return {
      pageIndex: 1,
      totalPage: 0,
      loadedOptions: [], // 已加载的选项
      filterText: '',
      options: [],
      originOptions: [], // 包含删除的信息
      originOptionsWithoutDelete: [], // 不包含删除的信息
      searchParents: [], // 筛选父级机构
      checkedItem: {}, // 当前选中的数据
      isNodeToggleEvent: false
    }
  },
  created () {
    this.originOptions = [...this.data]
    const id = this.props.id
    if (this.showCheckbox && this.checked) {
      const _checked = [...this.checked]
      this.checkedItem = this.originOptions.filter(child => _checked.includes(`${child[id]}`) || _checked.includes(+child[id]))
    } else if (!this.showCheckbox) {
      this.checkedItem = this.originOptions.find(child => `${child[id]}` === `${this.checked}`)
    }
    this.renderOptions()
  },
  computed: {
    getLabel () {
      return (item) => {
        const {label} = this.props
        let labelText = item[label]
        if (label.includes(',')) {
          const items = label.split(',').map(c => item[c])
          labelText = items.join(' - ')
        }
        return labelText
      }
    }
  },
  methods: {
    renderOptions () {
      this.originOptions = [...this.data]
      // this.totalPage = Math.ceil(this.originOptions.length / this.size)
      this.options = [...this.data].filter(item => item.show)// .filter(item => +item[this.props.status] !== +(this.props.statusValue || -1))
      const status = this.props.status || this.props.disabled // disabled 是为了支持上一个版本组件的适配
      if (status !== undefined) {
        this.options = [...this.options].filter(item => +item[status] !== +(this.props.statusValue || -1) && +item[status] !== -2)
      }
      this.originOptionsWithoutDelete = [...this.data].filter(item => `${item[status]}` !== `${this.props.statusValue || -1}` && +item[status] !== -2)

      // console.log('options = ', this.options, this.originOptions)
    },
    checkChange (item, deep = false) {
      console.log('item=', item)
      if (item.readonly) {
        return
      }
      if (deep && this.showCheckbox) { // 是否更新子节点
        item.checked = !item.checked
        const children = this.props.children
        const id = this.props.id
        const parentId = this.props.parentId
        if (+item[parentId] === 0) {
          this.options.forEach(c => {
            c.checked = item.checked
          })
        } else {
          this.options.filter(c => item[children].includes(c[id])).forEach(c => { // c.Value
            c.checked = item.checked
          })
        }
        // 需要过滤掉已删除的数据
        const status = this.props.status || this.props.disabled // disabled 是为了支持上一个版本组件的适配
        const handlerItems = this.originOptions.filter(c => item[children].includes(+c[id]) || item[children].includes(`${c[id]}`)).filter(c => +c[status] !== (+this.props.statusValue || -1) && +c[status] !== -2)
        console.log('handlerItems = ', handlerItems)
        /* handlerItems.map(c => {
          console.log(c[status])
        }) */
        if (item.checked) {
          this.checkedItem = [...this.checkedItem, ...handlerItems]
        } else {
          handlerItems.forEach(c => {
            const index = this.checkedItem.findIndex(f => f[id] === c[id])
            index !== -1 && this.checkedItem.splice(index, 1)
          })
        }
      }
      let checkedItem = this.options.filter(child => child.checked)
      if (!this.showCheckbox) {
        checkedItem = item
      } else {
        let useItems = []
        const id = this.props.id
        if (!deep) {
          if (!Array.isArray(this.checkedItem)) {
            this.checkedItem = []
          }
          const index = this.checkedItem.findIndex(child => child[id] === item[id])
          if (index === -1) {
            item.checked && this.checkedItem.push(item)
          } else {
            !item.checked && this.checkedItem.splice(index, 1)
          }

          const ids = this.checkedItem.map(child => child[id])
          checkedItem = this.originOptions.filter(child => ids.includes(child[id]))
        } else {
          const savedItems = [...this.checkedItem]
          useItems = savedItems.reduce((result, cur) => {
            const _item = this.options.find(child => child[id] === cur[id])
            if (!_item) {
              result.push(cur)
            }
            return result
          }, [])
        }

        checkedItem = [...useItems, ...checkedItem]
        // checkedItem = [...this.checkedItem]
        if (!item.checked) { // 查询子集（设置为 false）
          const removedChildIds = this.getChildIds(item)
          checkedItem = checkedItem.filter(child => !removedChildIds.includes(child[id]))
        }
        this.checkedItem = [...checkedItem]
      }

      // this.checkedItem = [...savedItems, ...checkedItem]
      console.log('checkedItem=', checkedItem)
      if ((!this.filterDelete || this.filterText === '') && this.showCheckbox) {
        const status = this.props.status || this.props.disabled // disabled 是为了支持上一个版本组件的适配
        const statusValue = (+this.props.statusValue || -1)
        checkedItem = checkedItem.filter(item => ![`${statusValue}`, `-2`].includes(`${item[status]}`))
      }

      this.$emit('change', checkedItem)
    },
    getChildIds (item) {
      const id = this.props.id
      const status = this.props.status || this.props.disabled // disabled 是为了支持上一个版本组件的适配
      const statusValue = this.props.statusValue || -1
      const children = this.props.children
      let childIds = (item[children] || []).reduce((result, cur) => {
        const _item = this.originOptions.find(child => child[id] === cur[id])
        if (_item && `${_item[status]}` === `${statusValue}`) {
          result.push(_item[id])
          let _tempResult = []
          if (_item[children] && _item[children].length > 0) {
            _tempResult = this.getChildIds(_item)
          }
          result = [...result, ..._tempResult]
        }
        return result
      }, [])
      return childIds
    },
    toggleTreeNode (item) {
      if (item.haveChild) {
        this.isNodeToggleEvent = true
        this.setTreeExpand(item, !item.expand)
      }
    },
    setTreeExpand (row, isExpand) {
      const status = this.props.status || this.props.disabled // disabled 是为了支持上一个版本组件的适配
      let options = this.originOptions.filter(item => +item[status] !== +(this.props.statusValue || -1) && +item[status] !== -2)
      if (this.filterText) {
        const val = this.filterText

        options = options.filter(item => item[this.props.label].indexOf(val) !== -1)
        if (this.filterDelete) {
          options = this.originOptions.filter(item => item[this.props.label].indexOf(val) !== -1)
        }
        const list = this.getParentFromChild(options, this.searchParents)
        options = list.map(item => ({
          ...item
          // show: true
          // expand: true
        }))
      }
      const id = this.props.id
      const matchObj = XEUtils.findTree(options, item => item[id] === row[id])
      row.expand = isExpand
      console.log('matchObj = ', matchObj, options)
      if (matchObj) {
        const _id = this.props.id
        const _child = this.props.children
        const children = options.filter(item => matchObj.item[_child].includes(`${item[_id]}`) || matchObj.item[_child].includes(+item[_id]))
        XEUtils.eachTree(children, (item, index, items, path, parent) => {
          item.show = parent ? parent.expand && parent.show : isExpand
        })
      }
      this.isNodeToggleEvent = false
      this.refreshTree(options)
    },
    refreshTree (options) {
      // const options = this.originOptions.filter(item => +item[status] !== +(this.props.statusValue || -1))
      const treeList = XEUtils.toTreeArray(options)
      this.options = treeList.filter(item => item.show)
    },
    getParentFromChild (items, outItems = []) {
      let _parentIds = items.map(item => item[this.props.parentId])
      let _items = items.map(item => item[this.props.id])// item.Value
      _parentIds = [..._parentIds, ..._items]
      let _parentItems = this.originOptions.filter(item => _parentIds.includes(`${item[this.props.id]}`) || _parentIds.includes(+item[this.props.id]))// item.Value
      outItems = [...outItems, ..._parentItems]
      return outItems
    },
    filter (val) {
      this.filterText = val
      const status = this.props.status || this.props.disabled
      if (val) {
        let filterItems = this.originOptions.filter(item => item[this.props.label].indexOf(val) !== -1)
        if (!this.filterDelete) {
          filterItems = this.originOptionsWithoutDelete.filter(item => item[this.props.label].indexOf(val) !== -1)
        }
        let list = this.getParentFromChild(filterItems, this.searchParents)
        this.options = list.map(item => ({
          ...item,
          show: true, // item.level < 4 ? item.show : true,
          expand: true
        }))
      } else {
        // this.options = [...this.loadedOptions] // this.data// .filter(item => `${item[this.props.status]}` !== `${this.props.statusValue || -1}`)
        this.options = [...this.data]// .filter(item => item.show)
        // const status = this.props.status || this.props.disabled
        this.options = [...this.data].filter(item => `${item[status]}` !== `${this.props.statusValue || -1}` && +item[status] !== -2)
        if (status !== undefined) {
          // this.options = this.loadedOptions.filter(item => `${item[status]}` !== `${this.props.statusValue || -1}`)
          this.options = [...this.data].filter(item => `${item[status]}` !== `${this.props.statusValue || -1}` && +item[status] !== -2)
        }
      }
      const id = this.props.id
      const items = Array.isArray(this.checkedItem) ? this.checkedItem : []
      this.options = this.options.map(item => ({
        ...item,
        checked: items.findIndex(child => child[id] === item[id]) !== -1
      }))
    },
    setCheckedKeys () {
      this.options.filter(item => item.checked).forEach(item => {
        item.checked = false
      })
      let item = this.showCheckbox ? [] : {}
      this.checkedItem = item
      this.$emit('change', item)
    }
  },
  watch: {
    'data': function (newVal, oldVal) {
      // this.originOptions.length === 0 && this.renderOptions()
      if (!this.isNodeToggleEvent) {
        this.renderOptions()
      }
    },
    'checked': function (newVal, oldVal) {
      const id = this.props.id
      if (this.showCheckbox && newVal && Array.isArray(newVal) && newVal.length > 0) {
        const _checked = newVal
        this.checkedItem = this.originOptions.filter(child => _checked.includes(`${child[id]}`) || _checked.includes(+child[id]))
      } else if (!this.showCheckbox && newVal) {
        this.checkedItem = this.originOptions.find(child => `${child[id]}` === `${newVal}`)
      } else if (this.showCheckbox && newVal && newVal.length === 0) {
        this.options.filter(item => item.checked).forEach(item => {
          item.checked = false
        })
        this.checkedItem = []
      }
    }
  }
}
</script>

<style lang="less">
@import url("../assets/less/color.less");
.custom-tree {
  max-height: 300px;
  overflow: auto;
  &__label {
    padding: 0;
    cursor: pointer;
  }
  &__delete {
    text-decoration: line-through;
    color: red;
  }
  &__active {
    /* background-color: @color;
    color: @white-color; */
    color: @color;
    font-weight: bold;
  }
  &__disabled {
    color: @placeholder-color;
    cursor: not-allowed;
  }
  &__row{
    line-height: 28px;
  }
  .el-icon {
    &__empty {
      width: 14px;
      display: inline-block;
    }
  }
  .leaf_1 {
    padding-left: 10px;
  }
  .leaf_2 {
    padding-left: 20px;
  }
  .leaf_3 {
    padding-left: 30px;
  }
  .leaf_4 {
    padding-left: 40px;
  }
  .leaf_5 {
    padding-left: 50px;
  }
  .leaf_6 {
    padding-left: 60px;
  }
  .leaf_7 {
    padding-left: 70px;
  }
  .leaf_8 {
    padding-left: 80px;
  }
  .leaf_9 {
    padding-left: 90px;
  }
  .leaf_10 {
    padding-left: 100px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/customTree.vue